import React from "react";
import { forwardRef } from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { useAppDispatch } from "../redux/hooks"
import { showSnackbar, snackbarData } from "../redux/modules/snackbarSlice"
import { useSelector } from "react-redux";

const Alert = forwardRef(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CustomizedSnackbars() {

    const dispatch = useAppDispatch();
    const snackbarOpen = useSelector(snackbarData).open;
    const snackbarType = useSelector(snackbarData).type;
    const snackbarMessage = useSelector(snackbarData).message;

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        dispatch(showSnackbar({ open: false, type: snackbarType, message: snackbarMessage }));
    };

    const openTest = () => {

        dispatch(showSnackbar({ open: true, type: "success", message: "" }));
    };

    return (
        <Stack spacing={2} sx={{ width: "100%" }}>


            <Snackbar open={snackbarOpen} anchorOrigin={{ horizontal: "right", vertical: "top" }} autoHideDuration={4000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={snackbarType} sx={{ width: "100%" }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Stack>
    );
}